export enum EvenTypeShortTitles {
  'specialty' = 'S',
  'demo' = 'D',
  'standard' = 'T',
  'private' = 'S'
}
